import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';

function List() {

    const pathFrontEnd = '/cbosynonyms/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}cbosynonyms/delete`,
        endpoint: config.endpoints.backend + 'cbosynonyms/getall'
    }

    let list = {
        labelTitle: 'Lista de Sinônimos CBO',
        showPrintButtons: true,
        canAdd: false,
        canEdit: false,
        canDelete: false,
        canView: false,
        viewActionColumn: false,
        columns: [
            {
                name: 'code',
                label: 'Código CBO'
            },
            {
                name: 'title',
                label: 'Sinônimo'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                canAdd={list.canAdd}
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
